import type { ContainerRow } from "@/lib/api";
import { Lock } from "lucide-react";
import { Fragment } from "react";
import { personName } from "./access-copy";

// What someone sees when they open a Boo they have no role in: who to ask.
export function BooNoAccess({ container }: { container: ContainerRow }) {
  const owners = container.owners ?? [];
  return (
    <div className="flex flex-1 flex-col items-center justify-center gap-4 p-6 text-center">
      <Lock className="size-9 text-muted-foreground" />
      <div className="flex max-w-md flex-col gap-1.5">
        <h2 className="text-lg font-semibold text-balance">You don't have access to {container.name}</h2>
        {owners.length > 0 ? (
          <p className="text-sm text-muted-foreground">Ask one of its owners to add you.</p>
        ) : (
          <p className="text-sm text-muted-foreground">
            This Boo doesn&apos;t have an owner right now. An owner or admin of your organization can take ownership of it.
          </p>
        )}
      </div>
      {owners.length > 0 && (
        <ul className="flex flex-col gap-1 text-sm">
          {owners.map((o) => (
            <li key={o.userId}>
              <span className="font-medium">{personName(o)}</span>
              {o.email && o.name && <span className="select-all text-muted-foreground"> · {o.email}</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

// Above the spend that org owners, admins and billing admins still see for a
// Boo they have no role in.
export function BooSpendOnlyNotice({ container }: { container: ContainerRow }) {
  const owners = container.owners ?? [];
  return (
    <div className="mx-6 mt-2 flex items-start gap-2 rounded-md bg-muted/60 px-3 py-2 text-sm text-muted-foreground">
      <Lock className="mt-0.5 size-3.5 shrink-0" />
      <p className="text-pretty">
        You don&apos;t have access to {container.name}, so you&apos;re only seeing its spend.{" "}
        {owners.length > 0 ? (
          <>
            Ask{" "}
            {owners.map((o, i) => (
              <Fragment key={o.userId}>
                {i > 0 && (i === owners.length - 1 ? (owners.length > 2 ? ", or " : " or ") : ", ")}
                <span className="font-medium text-foreground">{personName(o)}</span>
              </Fragment>
            ))}{" "}
            to add you.
          </>
        ) : (
          "It doesn't have an owner right now."
        )}
      </p>
    </div>
  );
}
